"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomProvider = void 0;
const injets_1 = require("injets");
const application_provider_1 = require("../pixi/application.provider");
const Room_engine_1 = require("./Room.engine");
let RoomProvider = class RoomProvider {
    constructor(gameModule, appProvider) {
        this.gameModule = gameModule;
        this.appProvider = appProvider;
    }
    removeCurrentRoom() {
        if (!this.currentRoomContainer) {
            return;
        }
        this.appProvider.camera.removeChild(this.currentRoomContainer);
    }
    create(roomModel) {
        return __awaiter(this, void 0, void 0, function* () {
            this.removeCurrentRoom();
            const roomEngine = this.gameModule.get(Room_engine_1.RoomEngine);
            yield roomEngine.init(roomModel);
            this.currentRoomContainer = roomEngine.container;
            this.appProvider.camera.addChild(roomEngine.container);
            this.appProvider.culling.addList(roomEngine.container.children);
        });
    }
    dispose() { }
};
RoomProvider = __decorate([
    injets_1.Provider(),
    __param(0, injets_1.Inject(injets_1.CURRENT_MODULE)),
    __metadata("design:paramtypes", [injets_1.ModuleRef,
        application_provider_1.ApplicationProvider])
], RoomProvider);
exports.RoomProvider = RoomProvider;
